import { render } from "./AdminNewsPaginated.vue?vue&type=template&id=6cbfa95b"
import script from "./AdminNewsPaginated.vue?vue&type=script&lang=js"
export * from "./AdminNewsPaginated.vue?vue&type=script&lang=js"

import "./AdminNewsPaginated.vue?vue&type=style&index=0&id=6cbfa95b&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__